"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowLeft, ArrowRight, CircleHelp } from "lucide-react";
import Link from "next/link";
import { PageEyebrow } from "@/components/public/page-eyebrow";
import { PUBLIC_CONTAINER, PUBLIC_PANEL_RADIUS, PUBLIC_SECTION_PY_CONTENT } from "@/components/public/public-layout-styles";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { ButtonLink } from "@/components/ui/button";
import type { ProductFaqItem } from "@/lib/product-faq";
import { cn } from "@/lib/utils";
interface FaqContentProps {
  items: readonly ProductFaqItem[];
  lastUpdated: string;
}
export function FaqContent(t0) {
  const $ = _c(17);
  const {
    items,
    lastUpdated
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn(PUBLIC_CONTAINER, "max-w-4xl", PUBLIC_SECTION_PY_CONTENT);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Link className="text-muted-foreground hover:text-foreground mb-8 inline-flex items-center gap-2 text-sm transition-colors" href="/"><ArrowLeft className="size-4" />Voltar ao início</Link>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <PageEyebrow className="mb-4" icon={CircleHelp}>Central de ajuda</PageEyebrow>;
    t4 = <h1 className="mb-4 max-w-[35ch] text-4xl font-semibold tracking-tight text-balance">Perguntas frequentes</h1>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== lastUpdated) {
    t5 = <div className="mb-12">{t3}{t4}<p className="text-muted-foreground text-pretty">Última atualização: {lastUpdated}</p></div>;
    $[4] = lastUpdated;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = cn("border-border/50 bg-card/50 border p-6 sm:p-8", PUBLIC_PANEL_RADIUS);
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [];
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== items) {
    t8 = items.map(_temp);
    $[8] = items;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t8) {
    t9 = <div className={t6}><Accordion className="w-full" defaultValue={t7} multiple={true}>{t8}</Accordion></div>;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <p className="text-muted-foreground text-base text-pretty sm:text-sm">Ainda precisa de ajuda? Fale com nosso time.</p>;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">{t10}<ButtonLink size="sm" variant="outline" href="/suporte">Falar com suporte<ArrowRight className="size-4" /></ButtonLink></div>;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t5 || $[15] !== t9) {
    t12 = <main className="relative z-10"><div className={t1}>{t2}{t5}{t9}{t11}</div></main>;
    $[14] = t5;
    $[15] = t9;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  return t12;
}
function _temp(item, index) {
  return <AccordionItem key={item.question} value={`item-${index}`}><AccordionTrigger className="text-left">{item.question}</AccordionTrigger><AccordionContent className="text-muted-foreground text-base leading-7">{item.answer}</AccordionContent></AccordionItem>;
}